import { useEffect } from 'react';
import type { AppNotice } from '../../types/notices/app-notice.type';
import { useAppNotices } from './use-app-notices';

/**
 * Registers a memoized notice for the lifetime of an eligible producer.
 * @param notice - Memoized presentation model, or null when ineligible.
 */
export const useAppNotice = (notice: AppNotice | null): void => {
  const { registerNotice } = useAppNotices();
  useEffect(() => {
    if (notice) return registerNotice(notice);
  }, [notice, registerNotice]);
};
